import { ConfirmButtonWithDialogProps } from "..";
import { MUTATIONS } from "../../../graphql";
import { useSnackbarMessage, useSnackbarMutation } from "../../../hooks";
import { ConfirmButtonWithDialog } from "../confirm_button_with_dialog";

export interface RemoveUserFromApartmentButtonProps
  extends Partial<Omit<ConfirmButtonWithDialogProps, "onClick">> {
  userId: string;
  apartmentId: string;
  onUserRemovedFromApartment: () => void;
}

export function RemoveUserFromApartmentButton(
  props: RemoveUserFromApartmentButtonProps
) {
  const {
    userId,
    apartmentId,
    onUserRemovedFromApartment,
    children,
    ...dialogButtonProps
  } = props;
  const { raiseSuccessSnackbar } = useSnackbarMessage();

  const [invokeRemoveUserFromApartment, { loading }] = useSnackbarMutation(
    MUTATIONS.REMOVE_USER_FROM_APARTMENT,
    {
      variables: {
        userId,
        apartmentId,
      },
      onCompleted: () => {
        raiseSuccessSnackbar("Utente rimosso con successo!");
        onUserRemovedFromApartment();
      },
    }
  );

  const onConfirm = () => {
    invokeRemoveUserFromApartment();
  };

  const onUndo = () => {};

  return (
    <ConfirmButtonWithDialog
      dialogProps={{
        fullScreen: false,
        title: "Rimuovi utente dall'appartamento?",
      }}
      dialogContent={"Confermi di voler rimuovere l'utente dall'appartamento?"}
      onConfirm={onConfirm}
      onUndo={onUndo}
      {...dialogButtonProps}
      disabled={loading}
    >
      {children}
    </ConfirmButtonWithDialog>
  );
}
